// extracted by mini-css-extract-plugin
export default {"wrapperSelect":"GroupSelection_wrapperSelect__SeQ4S","select":"GroupSelection_select__1LWyz"};